import { gql } from '@apollo/client';

export const FetchAllProjectAssetsQuery = gql`
  query FetchAssetsQuery($search: String, $sort: Sort, $pagination: Pagination) {
    getImages(search: $search, sort: $sort, pagination: $pagination) {
      info {
        count
        limit
        offset
        page
      }
      results {
        id
        projectId
        assetName
        assetType
        altText
        createdAt
        createdBy
        creatorUser {
          id
          fullName
          avatarUrl
        }
        updatedAt
        updatedBy
        url
        size
        height
        width
        mimeType
      }
    }
  }
`;

export const FetchRootAssetFolderQuery = gql`
  query FetchRootFolder($assetFilterInfo: ImageFilterInfoInput) {
    assetFolder(assetFilterInfo: $assetFilterInfo) {
      id
    }
  }
`;

export const FetchAssetsAndFoldersQuery = gql`
  query FetchAssetFolderQuery(
    $assetFilterInfo: ImageFilterInfoInput
    $pagination: Pagination
    $search: String
    $folderId: Long
    $recursive: Boolean
    $sort: Sort
  ) {
    assetFolder(
      assetFilterInfo: $assetFilterInfo
      pagination: $pagination
      search: $search
      folderId: $folderId
      recursive: $recursive
      sort: $sort
    ) {
      info {
        count
        limit
        offset
        page
      }
      name
      id
      content {
        ... on AssetSubfolder {
          __typename
          id
          name
        }
        ... on ImageAsset {
          __typename
          id
          projectId
          assetName
          altText
          assetType
          createdAt
          createdBy
          updatedByUser{
            id
            fullName
            avatarUrl
          }
          creatorUser {
            id
            fullName
            avatarUrl
          }
          updatedAt
          updatedBy
          url
          size
          height
          width
          mimeType
        }
      }
      ancestors {
        id
        name
      }
    }
  }
`;

export const CreateAssetFolderQuery = gql`
    mutation CreateAssetFolder($name: String!, $locationId: Long) {
        createAssetFolder(name: $name, locationId: $locationId)
  }
`;

export const RenameAssetFolderQuery = gql`
    mutation RenameAssetFolder($folderId: Long!, $newName: String!) {
      renameAssetFolder(folderId: $folderId, newName: $newName) {
        ... on FolderRenamed {
          success {
            folderId
            folderName
          }
        }
        ... on RenameFailure {
          failure {
            ... on FolderNameConflictFailure {
              id
              name
            }
            ... on FolderNotFoundFailure {
              id
            }
            ... on CannotRenameRootFolderFailure {
              id
            }
            ... on InvalidFolderNameFailure {
              id
              name
            }
          }
        }
      }
    }
`;

export const MoveAssetContentsAndFoldersQuery = gql`
  mutation moveAssetContentsAndFolders($folderIds: [Long!]!, $contentIds: [Long!]!, $destinationId: Long) {
  moveAssetContentsAndFolders(
    folderIds: $folderIds,
    contentIds: $contentIds,
    destinationId: $destinationId
  ){
    movedContent{
      id
      name
    }
    errors {
      __typename
      ... on FolderNotFoundFailure {
        id
      }
      ... on DestinationNotFoundFailure {
        id
      }
      ... on FolderIsAncestorOfDestinationFailure {
        id
        name
      }
      ... on FolderIsSameAsDestinationFailure {
        id
        name
      }
      ... on FolderNameConflictFailure {
        id
        name
      }
    }
  }
}
`;

export const FetchAssetTypesQuery = gql`
  query getAssetTypes {
    imageFileTypes
  }
`;

export const FetchImageSizeQuery = gql`
  query getImageSizes {
    imageSizes
  }
`;

export const FetchImageCreatorsQuery = gql`
  query getImageCreators {
    imageCreators {
      id
      fullName
    }
  }
`;

export const FetchImageModifiersQuery = gql`
  query getImageModifiers {
    imageModifiers {
      id
      fullName
    }
  }
`;

export const DeleteAssetsAndFoldersMutation = gql`
  mutation DeleteAssetContentsAndFolders($contentIds: [Long!]!, $folderIds: [Long!]!) {
  deleteAssetContentsAndFolders(contentIds: $contentIds, folderIds: $folderIds) {
    deletedContent {
      id
      name
      __typename
    }
    folderFailures {
      ... on FolderNotFoundFailure {
        id
        __typename
      }
      ... on CannotDeleteRootFolderFailure {
        id
        __typename
      }
      ... on CannotDeleteFolderWithWhatsAppContents {
        id
        __typename
      }
    }
  }
}
`;
